import React from 'react';
import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: React.ReactNode;
  href?: string;
  title?: string;
}

interface BreadcrumbProps extends React.ComponentPropsWithoutRef<'nav'> {
  items: BreadcrumbItem[];
}

export function Breadcrumb({ items, className = 'aegov-breadcrumb with-seperator', ...props }: BreadcrumbProps) {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <nav className={className} aria-label="Breadcrumb" {...props}>
      <ol>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const itemTitle = item.title || (typeof item.label === 'string' ? item.label : undefined);

          return (
            <li key={index}>
              {!isLast && item.href ? (
                <Link to={item.href} title={itemTitle}>
                  {item.label}
                </Link>
              ) : isLast ? (
                <span aria-current="page" title={itemTitle}>
                  {item.label}
                </span>
              ) : (
                <span title={itemTitle}>{item.label}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
